import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'
import moment from 'moment'

import IconMenu from 'material-ui/IconMenu'
import MenuItem from 'material-ui/MenuItem'
import IconButton from 'material-ui/IconButton'
import ArrowDropDown from 'material-ui/svg-icons/navigation/arrow-drop-down'

import financeActions from 'actions/financeActions'

import { reportPeriod } from 'selectors/reports'

let select = (state, props) => ({
	period: reportPeriod(state)
})

function setPeriods(){
	let startingPoint = "Jan 16"
	let periods = []
	let i = 0
	let next = true
	while(next){
		let date = moment(startingPoint, "MMM YY").add(i++, 'month').format("MMM YY")
		if(moment().subtract(2, "month") <= moment(date, "MMM YY")) next = false
		periods.push(date)
	}
	return R.reverse(periods)
}


export class PeriodSelect extends Component {
	state = { isOpen: false }
	toggleMenu = () => {
		this.setState({
			isOpen: !this.state.isOpen
		})
	}
	render () {
		let {props} = this
		let periods = setPeriods()
		return (
			<div
				className="period-holder"
				style={{display: "flex"}}
			>
				<div
					className="value"
					onClick={this.toggleMenu}
					style={{
						cursor: "pointer"
					}}
				>
					{props.period}
				</div>
				<IconMenu
					open={this.state.isOpen}
					onRequestChange={this.toggleMenu}
					iconButtonElement={
						<IconButton style={{paddingLeft: '0px', verticalAlign: 'middle', marginTop: '-3px'}}>
							<ArrowDropDown	color='#FFF'/>
						</IconButton>
					}
					onItemTouchTap={(evt, item) => {
						props.SET_PERIOD(item.key)
					}}
				>
					{periods.map((period) =>
						<MenuItem
							key={period}
							value={period}
							primaryText={period}
						/>
					)}
				</IconMenu>
			</div>
		)
	}
}
export default connect(select, financeActions)(PeriodSelect)



// WEBPACK FOOTER //
// ./src/routes/landlord/finances/PeriodSelect.js